import { apiJson } from '../api';

// Mirrors backend/app/repositories/article_list_repository.py
// LIST_NAME_MAX_LENGTH; pinned by backend/tests/test_list_name_policy_parity.py.
export const LIST_NAME_MAX_LENGTH = 30;

export async function getUserLists(): Promise<string[]> {
  return apiJson<string[]>('/api/lists');
}

export async function getArticleLists(storyId: string): Promise<string[]> {
  return apiJson<string[]>(`/api/stories/${encodeURIComponent(storyId)}/lists`);
}

export async function addArticleToList(storyId: string, tag: string): Promise<void> {
  await apiJson(`/api/stories/${encodeURIComponent(storyId)}/lists`, {
    method: 'POST',
    json: { tag },
  });
}

export async function removeArticleFromList(storyId: string, tag: string): Promise<void> {
  await apiJson(`/api/stories/${encodeURIComponent(storyId)}/lists/${encodeURIComponent(tag)}`, {
    method: 'DELETE',
  });
}
